import React from 'react'
import PropTypes from 'prop-types'

// Icon mở rộng
const ExpandIcon = ({ size = '24', color = 'white' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.25 4.5H19.5V9.75"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0205 4.97803L5.24908 18.7508"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75 19.5H4.5V14.25"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

ExpandIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
}

export default React.memo(ExpandIcon)
